import { Dispatch, createContext } from "react";
import { Panel } from "@radarly/models/panel";
import { Actions } from "./action";

export default createContext<{ state: Panel[]; dispatch: Dispatch<Actions> }>({
  state: [],
  dispatch: null,
});
